export function buildVisibilityRoles(
    isEmployee: boolean,
    isLoggedIn: boolean,
    isWebCustomer: boolean,
    isFsdCustomer: boolean,
    customerSegment: string
): Array<String> {
    const roles = [];

    if (isLoggedIn) {
        roles.push("logged_in_customer");
    } else {
        roles.push("anonymous");
    }

    if (isEmployee) {
        roles.push("employee");
    }

    if (isFsdCustomer) {
        roles.push("fsd_customer");

        switch (customerSegment) {
            case "HORECA":
                roles.push("segment_horeca");
                break;
            case "TRADER":
                roles.push("segment_trader");
                break;
            case "TRADER_FRANCHISE":
                roles.push("segment_trader_franchise");
                break;
            case "COMPANIES_AND_OFFICES":
            case "SERVICES":
                roles.push("segment_sco_services");
                break;
        }
    } else if (isWebCustomer) {
        roles.push("cash_and_carry_customer");
    }

    return roles;
}
